<template>
  <DashboardTemplate :navMenu="true">
    <div class="text-left pd-b-5">
      <h2 class="mg-less">
        <!-- คะแนนกิจกรรม {{ getPrefixLabel(prefix) }}{{ nameTh }} -->
        สรุปรายชื่อผู้เรียนหลักสูตร
      </h2>
      <p class="text-font-14">
        <span class="text-weight-bold">หลักสูตร </span
        ><span class="color-gray">{{ course.name }}</span>
      </p>
    </div>
    <div v-loading="loading">
      <ActivitySubjectDetailList
        :showUpdatedAt="true"
        :edit="edit"
        :courseScoreList="courseScoreList"
        :courseId="courseId"
        :userId="userId"
        :subjectSuccess="course?course.subject.length == course.subjectNumber:false"
        @checkAssignment="checkAssignment"
      />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivitySubjectDetailList from "@/components/activity/ActivitySubjectDetailList";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  components: {
    DashboardTemplate,
    ActivitySubjectDetailList,
  },
  data() {
    return {
      activeName: "1",
      edit: "false",
      courseId: "",
      userId: "",
      loading: true,
      prefix: "",
      nameTh: "",
      courseScoreList: null,
      course: "",
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchStudentsById();
    this.fetchPercentSubjects();
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.edit != "undefined") {
          this.edit = this.routeParams.edit;
          this.courseId = this.routeParams.courseId;
          this.userId = this.routeParams.userId;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
      }
    },
    fetchPercentSubjects() {
      let obj = {
        courseId: this.courseId,
        userId: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`percent/subjects`, obj)
        .then((res) => {
       
          if (res.data.success) {
            this.courseScoreList = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchPercentSubjects  error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.prefix = res.data.obj.titleName;
            this.nameTh = res.data.obj.nameTH;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsById error", e);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
    checkAssignment(id, status) {
      this.loading = true;

      let obj = {
        subjectId: id,
        userId: this.userId,
        status: status,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`check/assignment`, obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchPercentSubjects();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("checkAssignment error", e);
        });
    },
  },
};
</script>